import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './HamburgerMenu.css';

const MENU_ITEMS = [
  { label: 'home', path: '/' },
  { label: 'drawings', path: '/category/drawings' },
  { label: '3d prints', path: '/category/3d%20prints' },
  { label: 'crochet', path: '/category/crochet' },
  { label: 'soldering', path: '/category/soldering' },
  { label: 'painting', path: '/category/painting' },
  { label: 'miscellaneous', path: '/category/miscellaneous' }
];

function HamburgerMenu() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <div className="hamburger-menu">
      <button 
        className="hamburger-button" 
        onClick={toggleMenu}
        aria-label="Toggle menu"
      >
        <span className={`hamburger-icon ${isOpen ? 'open' : ''}`}>
          <span></span>
          <span></span>
          <span></span>
        </span>
      </button>
      
      <nav className={`menu-nav ${isOpen ? 'open' : ''}`}>
        <ul className="menu-list">
          {MENU_ITEMS.map((item) => {
            // Decode both paths for comparison
            const decodedPath = decodeURIComponent(location.pathname);
            const decodedItemPath = decodeURIComponent(item.path);
            const isActive = decodedPath === decodedItemPath || 
              (decodedItemPath !== '/' && decodedPath.startsWith(decodedItemPath));
            
            return (
              <li key={item.path}>
                <Link 
                  to={item.path} 
                  className={isActive ? 'active' : ''}
                  onClick={closeMenu}
                >
                  {item.label}
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>
      
      {isOpen && (
        <div className="menu-overlay" onClick={closeMenu}></div>
      )}
    </div>
  );
}

export default HamburgerMenu;
